module.exports = __webpack_public_path__ + "assets/img/xygl__d_5.f1bee394.png";